// extracted by mini-css-extract-plugin
export default {"title":"PopularDogBreedType_title__3Ucr1","row":"PopularDogBreedType_row__4ZHW6","loadMoreButton":"PopularDogBreedType_loadMoreButton__fogBV"};